module.exports = __webpack_public_path__ + "img/t6.a3899cb7.png";